'use client';
import { mergeOptions } from './mergeOptions.js';
import { getDecoratedResponsePromise } from './core/getDecoratedResponsePromise.js';
import { requestMethods } from './domain/constants.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var createInstance = function(defaults) {
    var _loop = function() {
        var method = _step.value;
        client[method] = function(input, options) {
            return getDecoratedResponsePromise(input, mergeOptions(defaults, options, {
                method: method
            }));
        };
    };
    var client = function(input, options) {
        return getDecoratedResponsePromise(input, mergeOptions(defaults, options));
    };
    for(var _iterator = _create_for_of_iterator_helper_loose(requestMethods), _step; !(_step = _iterator()).done;)_loop();
    client.create = function(newDefaults) {
        return createInstance(mergeOptions(newDefaults));
    };
    client.extend = function(newDefaults) {
        return createInstance(mergeOptions(defaults, newDefaults));
    };
    return client;
};
var client = createInstance();

export { client as default };
